var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.mode.id === 'cross-check')?_c('CrossCheck',{on:{"onGameExit":_vm.onGameExited}}):_vm._e(),(_vm.mode.id === 'initial-quiz')?_c('InitialQuiz',{on:{"onGameExit":_vm.onGameExited}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }